import React from 'react';
import PropTypes from 'prop-types';

import { Label } from 'containers/index';

const HeaderText = ({ value }) => (
  value && <Label name={value} invert />
);

HeaderText.defaultProps = {
  value: ''
};

HeaderText.propTypes = {
  value: PropTypes.string
};

export default HeaderText;



// WEBPACK FOOTER //
// ./src/components/HeaderText/HeaderText.js